import type { ReactNode } from 'react'

/** A single mobile-width surface panel: rounded, hairline border, soft shadow.
 *  The one repeated container shape for slot/assignment rows and the login
 *  card — deliberately plain (no desktop grid/table primitives).
 *
 *  `row` lays the children out horizontally (label left, actions right) instead
 *  of stacking them. It has to be a PROP, not a className: this component owns
 *  `flex-col`, and passing `flex-row` from outside does not win — Tailwind emits
 *  `.flex-col` after `.flex-row`, so the stacking survives regardless of class
 *  order. Callers that passed `className="flex items-center justify-between"`
 *  were silently rendering centered columns. */
export function Card({
  children,
  className,
  row = false,
}: {
  children: ReactNode
  className?: string
  row?: boolean
}) {
  return (
    <div
      className={[
        'rounded-lg bg-surface border border-line shadow-sm p-4 flex gap-3',
        row ? 'flex-row items-center justify-between' : 'flex-col',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  )
}
